import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from 'framer-motion';
import Image from "next/image";
import desktopimg1 from "../../public/images/slicksliderimg1.webp";
import desktopimg2 from "../../public/images/slickimg2.webp";
import desktopimg3 from "../../public/images/slicksimg3.webp";
import border from "../../public/images/border2.png"
import Contactuscoman from "../contactus/contactuscommon";


const thumbnails = [
  { src: "/images/slicksliderimg1.webp", alt: "tips for a successful interview" },
  { src: "/images/slickimg2.webp", alt: "10 things to during an interview" },
  { src: "/images/slicksimg3.webp", alt: "online assessment test, how to choose your career" },
];

function ServiceBaner() {

  const settings = {
    customPaging: function (i) {
      return (
        <img className="thumbnail w-full mb-32 lg:h-[120px] lg:mt-14" src={thumbnails[i].src} alt={thumbnails[i].alt} />
      );
    },
    dots: true, 
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, 
    autoplaySpeed: 4000,
    initialSlide: 1,
    pauseOnHover: true,
    swipeToSlide: true,
    arrows: false,
    afterChange: (current) => {
      const thumbnails = document.querySelectorAll(".thumbnail");
      thumbnails.forEach((thumb, index) => {
        thumb.classList.toggle("active", index === current);
      });
    },
  };

  return (
    <>
      <div className='solutionbaner_overlay'>
        <div className='bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#51A9FF] to-transparent opacity-40 rounded-full h-[500px] w-[750px] z-0 blur-lg absolute top-3/4 -left-4 -translate-x-1/2 -translate-1/2'></div>
        <div className='solutions01'>
          <div className='text-start side_main_gap my-10'>
            <div className='grid grid-cols-1 lg:grid-cols-2'>
              <div className='mt-[80px] ml-7'>
                <div className='text-xl font-bold text-[#FF5349] -ml-7 '> #WeDriveEasyCampus</div><br /><br />
                <div className="solution_02">
                  <h4 className="meetthe_text">
                    Meet The <span className="shadowText">Future of</span>
                  </h4>
                  <h4 className="shadowText campus_text">
                    <span>C</span>
                    AMPUS
                  </h4>
                  <div className="solution_03">
                    <h4 className="drive_text">DRIVE</h4>
                    <h4 className="drive_solution shadowText">SOLUTIONS</h4>
                  </div>
                  <div className='solution_border'>
                  <Image src={border} alt='rank-red' width={600}/>
                </div>
                </div>
                <motion.div
                  initial={{ y: -100, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.4, y: { type: "spring", stiffness: 60 }, opacity: { duration: 1 }, ease: "easeIn", duration: 1 }}
                  className='pt-2 text-[18px] text-center lg:-ml-36  border-black '>
                  A unique and powerful platform<br /> designed to transform your approach, catering specifically to<br /><span className="font-[900]"> Corporates, Colleges/Universities, and Students.</span>
                </motion.div>
                <div className="example-container">
                  <div className="hex-button">
                    <span className="lg:text-2xl">Save Time&nbsp;|&nbsp;</span>
                    <span className="lg:text-2xl font-[650]">Save Energy&nbsp;|&nbsp;</span>
                    <span className="lg:text-2xl font-black">Save Cost</span>
                  </div>
                </div>
              </div>
              <div className="slider-container ">
                <Slider {...settings}>
                  <div className="-ml-4 lg:-ml-0">
                    <Image src={desktopimg1} alt="mock interview practice" className="h-[300px] w-[500px]"/>
                  </div>
                  <div className="-ml-3 lg:-ml-0">
                    <Image src={desktopimg2} alt="mock interview online" className="h-[300px] w-[500px]"/>
                  </div>
                  <div className="-ml-4 lg:-ml-0">
                    <Image src={desktopimg3} alt="mock interview for students" className="h-[300px] w-[500px]"/>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
        <Contactuscoman />
      </div>
    </>
  );
}

export default ServiceBaner;